export const BERT_REPORT_CHART_CONFIG = {
  series: [
    {
      id: 1,
      name: 'TX ULR',
      unit: 'Mbps',
      field: 'tx-ulr',
      isHide: false
    },
    {
      id: 2,
      name: 'RX ULR',
      unit: 'Mbps',
      field: 'rx-ulr',
      isHide: false
    },
    {
      id: 3,
      name: 'FLR',
      unit: '%',
      field: 'frame-loss-ratio',
      sla: 'frame-loss-ratio-threshold',
      isHide: false
    },
    {
      id: 4,
      name: 'FD',
      unit: 'ms',
      field: 'fd-current',
      sla: 'frame-delay-threshold',
      isHide: false
    },
    {
      id: 5,
      name: 'FDV',
      unit: 'ms',
      field: 'fdv-current',
      sla: 'latency-FDV-maximum',
      isHide: false
    }
  ]
};
